import React from "react";
import * as Sentry from "@sentry/react-native";
import { Slot } from "expo-router";

import { initializeSentry } from "@/utils/sentry";
import { SessionProvider } from "@/context/auth/AuthContext";

function RootLayout(): React.JSX.Element {
  initializeSentry("Web");
  return (
    <SessionProvider>
      <Slot />
    </SessionProvider>
  );
}

export default Sentry.wrap(RootLayout);
